/* DRIPSTORE · Página de producto
   Preguntas frecuentes: solo una abierta a la vez.
   Usa el atributo nativo `name` de <details> (acordeón exclusivo del navegador), así que
   no reemplaza ni interfiere con el acordeón de Horizon. */
(function () {
  function init() {
    document.querySelectorAll('.drip-extras details').forEach(function (details) {
      if (!details.hasAttribute('name')) details.setAttribute('name', 'drip-faq');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
